import moment from 'jalali-moment';
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import globalEnum from '../../enums/globalEnum';
import { setLoading } from '../../services/reducers/homeSlice';
import { middle } from '../../services/reducers/popupSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';
import { Sidebar } from '../Layout/Sidebar';
import ShelfPickingModal from './ShelfPickingModal';
import orderStatus = globalEnum.orderStatus;
import orderStatus2 = globalEnum.orderStatus2;
import { useAppSelector } from '../../services/store';
import userRole = globalEnum.userRole;

const OrderManage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const userReducer = useAppSelector(state => state.userReducer);
  const [form, setForm] = useState<any>({
    isMulti: false,
    orderProducts: [],
    transportation: 0,
    finalPrice: 0,
    discountAmount: 0,
    productId: null
  });
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const send = async () => {
    // if (form.status === orderStatus.WarehouseApproved && userReducer?.profile?.role === userRole.warehouse) {
    //   dispatch(middle(
    //     <ShelfPickingModal
    //       orderId={Number(id)}
    //       orderProducts={form.orderProducts}
    //       onComplete={() => navigate(-1)}
    //     />
    //   ));
    //   return;
    // }

    dispatch(setLoading(true));
    let addressRes, userRes, verifyNationalCode;

    if (!id) {
      userRes = await restApi(
        process.env.REACT_APP_BASE_URL + '/admin/user/basic/' + (form?.user?.id || '')
      ).post({
        name: form.user.name,
        lastName: form.user.lastName,
        nationalCode: form.user.nationalCode,
        phoneNumber: form.user.phoneNumber,
        isVerified: verifyNationalCode?.code == 200 || form.user.isVerified
      });

      if (form.address) {
        addressRes = await restApi(
          process.env.REACT_APP_BASE_URL + '/admin/address/basic/' + (form?.address?.id || '')
        ).post({
          title: form.address.title,
          phoneNumber: form.address.phoneNumber,
          description: form.address.description,
          vahed: form.address.vahed,
          pelak: form.address.pelak,
          userId: userRes.data?.id
        });
      }
    }

    const res = await restApi(
      process.env.REACT_APP_BASE_URL + '/admin/order/basic/' + (id || ''),
      true
    ).post({
      date: form.date,
      time: form.time,
      status: form.status,
      finalPrice: form.finalPrice,
      price: form.price,
      productId: form.productId,
      discountAmount: form.discountAmount,
      transportation: form.transportation,
      addressId: form.address?.id || addressRes?.data?.id,
      userId: form.user?.id || userRes?.data?.id,
      isMulti: form.isMulti,
      isUrgent: form.isUrgent,
    });

    if (res.code === 200) {
      const productRes = await restApi(
        process.env.REACT_APP_BASE_URL + '/admin/order/products/' + res.data.id
      ).put({
        products: form.orderProducts.map((e: any) => ({
          productId: e.productId,
          count: e.count
        }))
      });

      if (productRes.code === 1313) {
        Swal.fire({
          title: 'ناموفق',
          text: "تعداد کالای انتخاب شده بیشتر از موجودی است",
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
        dispatch(setLoading(false));
        return;
      }

      const statusRes = await restApi(
        process.env.REACT_APP_BASE_URL + '/admin/order/status/' + res.data.id
      ).put({
        status: form.status,
      });

      Swal.fire({
        title: 'موفق',
        text: 'سفارش با موفقیت ویرایش شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate(-1);
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data || 'خطایی رخ داده است',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const list = () => {
    const rows: ReactElement[] = [];
    form?.orderProducts?.map((orderProduct: any, index: number) => {
      const key = form.orderProducts?.findIndex((e: any) => e.productId == orderProduct.productId);
      const userAccess = form.user?.accesses?.find(
        (e: any) => e.entityType == 'Product' && e.entityId == orderProduct.productId
      );
      const productObj = products.find((e: any) => e.id == orderProduct.productId);

      rows.push(
        <tr className="" key={'product' + index}>
          <td className="quantity">
            <div className="quantityButtom">
              <i className="tablePlusIcon" onClick={(e: any) => {
                setForm((prev: any) => {
                  const cp = { ...prev };
                  cp.orderProducts[key].count = Number(cp.orderProducts[key].count) + 1;
                  return cp;
                });
              }}></i>
              <input
                className="quantityNumber"
                value={orderProduct.count}
                onChange={(input) => setForm((prev: any) => {
                  const cp = { ...prev };
                  cp.orderProducts[key].count = Number(input.target.value);
                  return cp;
                })}
              />
              <i className="tableCollapsIcon" onClick={(e: any) => {
                setForm((prev: any) => {
                  const cp = { ...prev };
                  if (cp.orderProducts[key].count > 1) {
                    cp.orderProducts[key].count = Number(cp.orderProducts[key].count) - 1;
                  }
                  return cp;
                });
              }}></i>
            </div>
          </td>
          <td>{productObj?.commerceCount}</td>
          <td>{productObj?.boxCount || 0} × {productObj?.itemsPerBox || '—'}</td>
          <td>{productObj?.rollCount || 0} × {productObj?.itemsPerRoll || '—'}</td>
          <td className="">
            <Select
              className="selectOrderManage"
              options={products
                .filter((e: any) => e.price > 0)
                .map((e: any) => ({
                  value: e.id,
                  label: e?.title + ' - ' + e.sku
                }))}
              value={{
                value: orderProduct.productId,
                label: productObj?.sku
              }}
              onChange={(selected: any) => {
                setForm((prev: any) => {
                  const cp = {...prev};
                  if (key == undefined || key < 0) {
                    cp.orderProducts = [
                      ...prev.orderProducts,
                      {
                        productId: selected.value,
                        itemsPerUnitType: userAccess?.unitType == 'box' ?
                          productObj?.itemsPerBox :
                          productObj?.itemsPerRoll
                      }
                    ];
                  } else {
                    cp.orderProducts[key] = {
                      ...cp.orderProducts[key],
                      productId: selected.value,
                      itemsPerUnitType: userAccess?.unitType == 'box' ?
                        productObj?.itemsPerBox :
                        productObj?.itemsPerRoll
                    };
                  }
                  return cp;
                });
              }}
            />
          </td>
          <td>{index + 1}</td>
          <td className="minWidth50">
            <i
              className="cancelSvg"
              onClick={() => setForm((prev: any) => ({
                ...prev,
                orderProducts: prev.orderProducts.filter((e: any) => e.productId != orderProduct.productId)
              }))}
            ></i>
          </td>
        </tr>
      );
    });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    if (id) {
      const res = await restApi(endpoints.order.single + id, true).get();
      setForm({
        status: res.data?.status,
        finalPrice: Number(res.data?.finalPrice),
        price: res.data?.price,
        discountAmount: res.data?.discountAmount,
        orderProducts: res.data?.orderProducts,
        address: res.data?.address,
        user: res.data?.user,
        createdAt: res.data?.createdAt,
      });
    }

    const res = await Promise.all([
      restApi(endpoints.product.awaitCommerce, true).get()
    ]);

    setProducts(res[0].data);
    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchUser = async (phoneNumber: string) => {
    const res = await restApi(endpoints.user.findBy, true).get({ phoneNumber: phoneNumber });
    if (res.code == 200) {
      setForm((prev: any) => ({ ...prev, user: res.data }));
    }
  };

  useEffect(() => {
    if (form?.orderProducts.length > 0 && products.length > 0) {
      const newPrice = form.orderProducts?.reduce((acc: number, curr: any) =>
        acc + Number(products?.find((e: any) => e.id == curr.productId)?.price *
          Number(curr.count) * curr.itemsPerUnitType), 0
      );
      setForm((prev: any) => ({
        ...prev,
        price: newPrice,
        finalPrice: newPrice - Number(form?.discountPrice || 0)
      }));
    }
  }, [JSON.stringify(form?.orderProducts), form?.discountPrice, products]);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <button className="dashboardHeader keepRight" onClick={send}>
            <p>ثبت سفارش</p>
          </button>
          <span>
              <h1 className="sideBarTitle">بازگشت به صفحه لیست سفارش ها</h1>
              <h1 className="dashBoardTitle">ویرایش سفارش</h1>
            </span>
          <i className="backAdd" onClick={() => navigate('/order')}></i>
        </div>

        <section className="topRow">
          <div className="infoSection"></div>
          <div className="infoSection">
            <h1 className="dashBoardTitle">اطلاعات سفارش</h1>
            <div className="userInfoContainer">
              <label className="sideBarTitle">وضعیت سفارش</label>
              <Select
                name='status'
                value={{
                  value: Object.keys(orderStatus2).find(e => e == form?.status) || 'WaitForCommerceBearingApproval',
                  label: orderStatus2[Object.keys(orderStatus2).find(e => e == form?.status) || 'WaitForCommerceBearingApproval']
                }}
                defaultValue={{
                  value: 'WaitForCommerceBearingApproval',
                  label: orderStatus2['WaitForCommerceBearingApproval']
                }}
                options={Object.entries(orderStatus2).map(([key, value]) => ({
                  value: key,
                  label: value
                }))}
                className="dashCardLog"
                id="infoTitle"
                onChange={(selected: any) => setForm((prev: any) => ({
                  ...prev,
                  status: selected.value
                }))}
              />
              <label className="sideBarTitle">تاریخ</label>
              <input
                className="editProductInput"
                value={(form?.date || moment().add(2, 'd').format('jYYYY/jMM/jDD'))}
                onChange={(input) => setForm((prev: any) => ({
                  ...prev,
                  date: input.target.value
                }))}
              />
            </div>
          </div>
        </section>

        <section className="bottom width100">
          <h6 className="dashBoardTitle">محصولات</h6>
          <table className="productTable">
            <thead className="editOrderTable">
            <th className="sideBarTitle center">تعداد</th>
            <th className="sideBarTitle center">تعداد در حال فروش</th>
            <th className="sideBarTitle center">تعداد کارتن قوطی</th>
            <th className="sideBarTitle center">تعداد کارتن رولی</th>
            <th className="sideBarTitle center">محصول</th>
            <th className="sideBarTitle center">ردیف</th>
            <th className="sideBarTitle center"></th>
            </thead>
            <tbody>
            {list()}
            <tr className="addProductTr">
              <td
                className="addProductButton clickable"
                onClick={() => setForm((prev: any) => ({
                  ...prev,
                  orderProducts: [...prev.orderProducts, {productId: 1, count: 1}]
                }))}
              >
                اضافه کردن محصول
              </td>
            </tr>
            </tbody>
          </table>
        </section>
      </main>
      </body>
    </>
  );
};

export default OrderManage;